// Quiet "arc approximated for display" hint (T34a). Rendered by the peek popover, the expanded-
// dialog map pane, and the two-cell compare dialog whenever a curved geometry (CircularString /
// CurvePolygon / …) is shown — the map draws a densified polyline, but Copy WKT / export keep the
// exact curve. Fires `feature:spatial_curve_render` ONCE per mount (a curve was actually displayed).

import { useEffect } from 'react';
import { Spline } from 'lucide-react';
import type { DatabaseEngineId } from '../../../../core/engines/engineTypes';
import { useAnalytics } from '../../../../core/analytics';

export function SpatialCurveApproxHint({ engine, className }: { engine: DatabaseEngineId; className?: string }) {
  const { track } = useAnalytics();

  useEffect(() => {
    track('feature:spatial_curve_render', { engine });
    // Fire once per mount (a curved geometry became visible) — not on every re-render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className={`flex items-center gap-1.5 text-[11px] leading-tight text-muted-foreground ${className ?? ''}`}
      data-testid="spatial-curve-approx-hint"
    >
      <Spline className="h-3 w-3 shrink-0" aria-hidden="true" />
      <span>Arc approximated for display · copied WKT stays curved.</span>
    </div>
  );
}
